module.exports = function (func, wait, immediate, onTrigger) {
    let timeout
    return function () {
        const context = this
        const args = arguments

        if (onTrigger) {
            onTrigger.apply(context, args)
        }

        clearTimeout(timeout)

        if (immediate && !timeout) {
            func.apply(context, args)
            immediate = false
        } else {
            const later = function () {
                timeout = null
                if (!immediate) {
                    func.apply(context, args)
                }
            }
            timeout = setTimeout(later, wait)
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/debounce.js